var $5ef0bd350b9637e3$exports = {};
$5ef0bd350b9637e3$exports = {
    "clear": `Skaidrus`,
    "invalid": `(netinkama)`,
    "loading": `\u{12E}keliama...`,
    "noResults": `Be rezultat\u{173}`
};


export {$5ef0bd350b9637e3$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
